import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { businessInfo } from '../data/mock';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Show tooltip after 3 seconds
    const timer = setTimeout(() => {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 5000);
    }, 3000);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  const handleClick = () => {
    window.open(
      `https://wa.me/${businessInfo.whatsapp}?text=Hola! Me gustaría hacer una consulta.`,
      '_blank'
    );
  };

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div
        className={`fixed bottom-6 right-6 z-50 transition-all duration-300 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
        }`}
      >
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-full right-0 mb-2 animate-in slide-in-from-bottom-2 fade-in duration-300">
            <div className="bg-gray-900 text-white px-4 py-2 rounded-lg shadow-xl text-sm whitespace-nowrap relative">
              ¿Necesitas ayuda? ¡Escríbenos!
              <div className="absolute -bottom-1 right-4 w-2 h-2 bg-gray-900 transform rotate-45"></div>
            </div>
          </div>
        )}

        {/* Button */}
        <button
          onClick={handleClick}
          className="group relative w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 animate-pulse hover:animate-none"
          aria-label="Contactar por WhatsApp"
        >
          <MessageCircle className="w-8 h-8 text-white" />
          
          {/* Ripple effect */}
          <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-75"></span>
        </button>
      </div>
    </>
  );
};

export default WhatsAppButton;
